import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import * as BackstageConstants from '../../../constants';
import * as D from '../../../deps';
import BackstageAbout from '../../BackstageAbout';
import CuratedPlaylists from '../../common/CuratedPlaylists';
import CuratedStations from '../../common/CuratedStations';
import ListenerCountSubtitleLarge from '../../common/ListenerCountSubtitleLarge';
import LayoutManager from '../../layout/LayoutManager';

import CuratorSidebarButtons from './CuratorSidebarButtons';

export const BackstageCuratorContent = props => {
  const {
    artUrl,
    bio,
    children,
    curatedPlaylists,
    curatedStations,
    curatorUrl,
    hasPlayableContent,
    headerArtUrl,
    isLoaded,
    isMobileWeb,
    listenerCount,
    name,
    pandoraId,
    playableContentType,
    playablePandoraId,
    socialLinks,
  } = props;

  const sidebarButtonsProps = {
    curatorPandoraId: pandoraId,
    hasPlayableContent,
    playableContentType,
    playablePandoraId,
    shareableUrlPath: curatorUrl || `/curator/${props.pandoraId}`,
  };

  const hasSocialLinks = !Object.values(socialLinks).every(value => value === '');

  const childrenProps = {
    description: bio,
    descriptionTitle: <FormattedMessage {...BackstageConstants.messages.about} />,
    ...props,
  };

  const mainContent = children ? (
    React.cloneElement(children, childrenProps)
  ) : (
    <React.Fragment>
      {curatedStations.length > 0 && (
        <CuratedStations
          isFirstSection={true}
          name={name}
          numberStations={curatedStations.length}
          pandoraId={pandoraId}
          stations={curatedStations}
        />
      )}
      {curatedPlaylists.length > 0 && (
        <CuratedPlaylists
          isFirstSection={!curatedStations.length}
          name={name}
          numberPlaylists={curatedPlaylists.length}
          pandoraId={pandoraId}
          playlists={curatedPlaylists}
        />
      )}
      {(bio || hasSocialLinks) && (
        <BackstageAbout
          backgroundImgAlt={name}
          backgroundImgUrl={headerArtUrl}
          bio={bio}
          isFirstSection={!curatedStations.length && !curatedPlaylists.length}
          pandoraId={pandoraId}
          socialLinks={socialLinks}
        />
      )}
    </React.Fragment>
  );

  return (
    <LayoutManager
      hasCuratorPrograms={hasPlayableContent}
      heroImageUrl={artUrl}
      isHeaderInSidebar={true}
      isMobileDevice={isMobileWeb}
      mainContent={mainContent}
      name={name}
      // pandoraId only gets passed once the full data has been loaded to prevent duplicate events due to a change in hasCuratorPrograms
      pandoraId={isLoaded && pandoraId}
      shareableUrlPath={curatorUrl || `/curator/${props.pandoraId}`}
      sidebarButtons={!isMobileWeb && <CuratorSidebarButtons {...sidebarButtonsProps} />}
      subTitleLrg={<ListenerCountSubtitleLarge stationListenerCount={listenerCount} />}
    />
  );
};

export function mapStateToProps(state) {
  return {
    isMobileWeb: D.isMobileWeb(state),
  };
}

BackstageCuratorContent.propTypes = {
  children: PropTypes.element,
  pandoraId: PropTypes.string,
  artUrl: PropTypes.string,
  headerArtUrl: PropTypes.string,
  name: PropTypes.string,
  listenerCount: PropTypes.number,
  curatorUrl: PropTypes.string,
  isLoaded: PropTypes.bool,
  isMobileWeb: PropTypes.bool,
  playablePandoraId: PropTypes.string,
  hasPlayableContent: PropTypes.bool,
  playableContentType: PropTypes.string,
  curatedStations: PropTypes.array,
  curatedPlaylists: PropTypes.array,
  bio: PropTypes.string,
  socialLinks: PropTypes.shape({
    twitterUrl: PropTypes.string,
    instagramUrl: PropTypes.string,
    facebookUrl: PropTypes.string,
    websiteUrl: PropTypes.string,
  }),
};

export default connect(mapStateToProps)(BackstageCuratorContent);
